import styled, { keyframes, injectGlobal } from 'styled-components';
import { lighten, darken } from 'polished'
import { Link } from 'react-router-dom';
import * as variables from './variables';
import * as mixin from './mixins';
import downloadImage from '../images/download.svg';
import arrow from '../images/arrow.svg';
import pizza from '../images/Pizza-small.jpg';
import sushi from '../images/Sushi-small.jpg';
import samosas from '../images/Samosas-small.jpg';
import toolbox from '../images/toolbox.svg';

injectGlobal`
  p {
    color: #222;
    line-height: 1.4;
    margin: 0 0 0.75em 0;
  }
  a {
    color: #0077cc;
    cursor: pointer;
    &:hover {
      color: #32bfcc;
    }
  }
  h1, h2, h3 {
    color: #222;
    margin: 0 0 0.3em 0;
  }
  .no-mobile {
    display: none;
    @media (min-width: 600px) {
      display: block;
    }
  }
  .mobile-only {
    display: block;
    @media (min-width: 600px) {
      display: none;
    }
  }
  .exceeded {
    color: red;

    & + p { color: red; }
  }
  .hazard {
    height: 1em;
    vertical-align: top;
  }
  .prepended {
    display: flex;
    align-items: center;

    span {
      font-size: 1.2em;
      margin-right: 5px;
    }
  }
  .collapsible-content {
    display: flex;
  }
  .invitation-preview {
    width: 100%;
    @media (min-width: 1200px) {
      width: 85%;
    }
    @media (max-width: 810px) {
      .invitation-button {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
  .uploadButton {
    background: ${variables.colours.olive};
    padding: 10px 32px;
    box-shadow: 0px 10px 25px rgba(0,0,0,0.2);
    cursor: pointer;
    text-align: center;
    border-radius: 22.5px;
    display: inline-block;
    line-height: ${(25/16)};
    color: white;
    font-weight: 500;
    word-break: none;
    white-space: nowrap;
    margin-left: 10px;
    text-decoration: none;
    outline: none;
    border: none;
    transition: background-color 0.2s ease-out, color 0.2s ease-out;
    &:hover {
      background: white;
      color: black;
    }
  }
  .upload-progress {
    height: 100%;
    background: ${variables.colours.olive};
    display: inline-block;
    border-radius: 8px;
    opacity: 0;
    margin-bottom: 10px;
  }
  .small-text {
    input {
      font-size: 100%;
    }
  }

  .new-guest {
    width: 100%;
    margin-bottom: 10px;

    @media (min-width: 800px) {
      width: 23%;
      margin-right: 2%;
      margin-bottom: 0;
      &.email { width: 48%; }
    }
  }

  .invite-button {
    @media (max-width: 800px) {
      width: 100%;
      margin: 0 0 20px 0 !important;
    }
  }

  .change-btn {
    background: ${variables.colours.grey};
    padding: 10px 32px;
    margin-top: 8px;
    cursor: pointer;
    text-align: center;
    border-radius: 22.5px;
    display: block;
    width: 116px;
    color: black;
    text-decoration: none;
  }
`;

export const Header = styled.header`
  color: ${variables.colours.white};
  background-color: ${variables.colours.olive};
  height: ${variables.headerHeight};
  padding: 10px;
  @media (min-width: 600px) {
    padding: 20px;
  }
  a {
    color: white;
  }
`;

export const Main = styled.main`
  ${props => props.width ? 'width: ${props.width};' : 'max-width: 600px;'};
  @media (min-width: 600px) {
    min-width: 400px;
  }
  margin: 0 auto;
  font-family: ${variables.fonts.body};
`;

export const Heading = styled.h1`
  font-size: 2.2em;
  font-family: ${variables.fonts.heading};
  font-weight: 600;
  text-align: center;
`;

export const SubHeading = styled.h2`
  text-align: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Notification = styled.div`
  position: sticky;
  top: 0px;
  z-index: 1;
  background-color: ${props => props.type};
  color: ${props => props.foregroundColor};
  padding: 10px;
  text-align: center;
  border-radius: 7px;
  margin-bottom: 20px;
  &:empty { display: none; }
  animation: ${fadeIn} 0.3s linear;
  animation-fill-mode: forwards;
  a {
    font-weight: bold;
    color: white;
  }
`;

export const WelcomeNotice = styled.p`
  color: ${variables.colours.black};
  max-width: 600px;
  line-height: 1.5;
  padding-left: 15px;
  margin: 0 0 20px;
`;

export const FormRow = styled.div`
  ${mixin.spaceBetween}
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: 20px;
  @media (min-width: 400px) {
    margin-bottom: 20px;
  }
  padding: 0 5px 0;
`;

export const TightFormRow = styled(FormRow)`
  margin-bottom: 20px;
`;

export const FormRowReverse = styled(FormRow)`
  align-items: flex-start;
  @media (min-width: 400px) {
    flex-direction: row-reverse;
  }
`;

export const InternalRow = styled.div`
  margin-bottom: 20px;
  @media (min-width: 400px) {
    margin-bottom: 30px;
  }
`;

export const Label = styled.label`
  display: block;
  margin-left: 15px;
  margin-bottom: 5px;
  color: rgba(39,37,37,0.9);

  ${props => props.required ? `
    &:after {
      color: ${variables.colours.orange}
      content: '*';
    }
  ` : ''}
`;

export const FormField = styled.input`
  border: ${props => props.public ? '0' : "1px solid #ccc"};
  ${mixin.FormField}
  ${mixin.removeFocusOutline}
`;

export const FormFieldArea = styled.textarea`
  ${mixin.FormField}
  border: 1px solid #ccc;
  border-radius: 10px;
  height: auto;
  padding: 10px;
  margin-bottom: 0px;
`;

export const TextFieldLabel = styled.div`
  ${mixin.spaceBetween}
  align-items: center;
`;

export const HalfWidthFieldGroup = styled.div`
  width: 100%;
  & + & {
    margin-top: 20px;
  }
  @media (min-width: 400px) {
    width: 48%;
    & + & {
      margin-top: inherit;
    }
  }
`;

export const FullWidthFieldGroup = styled.div`
  width: 100%;
`;

export const FullWidthFieldGroupHighlighted = FullWidthFieldGroup.extend`
  border-left: 3px solid #ffd804;
  padding-bottom: 15px;
`;

export const Button = styled.input`
  margin: 0 auto;
  border: 0;
  appearance: none;
  text-decoration: none;

  background-color: ${variables.colours.primary};
  ${props => props.secondary ? "background-color: " + variables.colours.olive : ''};

  color: ${variables.colours.white};
  min-width: 185px;
  padding: 10px 32px;
  border-radius: 22.5px;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  line-height: ${(25/16)};
  box-shadow: 0px 10px 25px rgba(0,0,0,0.2);
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease-out, color 0.2s ease-out;

  &:hover {
    background-color: ${variables.colours.offwhite};
    color: ${variables.colours.black};
  }

  &:disabled {
    pointer-events: none;
    background-color: ${variables.colours.lightGrey};
  }

  ${mixin.removeFocusOutline}
`;

export const ButtonLink = Button.withComponent(Link)

export const PlainButton = styled.div`
  ${mixin.buttonStyles}
  transition: background-color 0.2s ease-out, color 0.2s ease-out;
  background-color: ${variables.colours.olive};
  &:hover {
    background-color: ${variables.colours.offwhite};
    color: ${variables.colours.black};
  }
`;

export const MiniButton = styled.div`
  ${mixin.buttonStyles}
  font-size: 15px;
  padding: 4px 13px 5px;
  margin: 0px;
  border-radius: 22.5px;
  background-color: ${variables.colours.olive};
  box-shadow: 0px 0px 0px rgba(0,0,0,0);
  display: inline-block;
  &:hover {
    background-color: ${lighten(0.12, variables.colours.orange)};
  }
  &.selected {
    background-color: ${variables.colours.orange};
  }
`;

export const PlainLinkButton = PlainButton.withComponent('a');

export const FilterButton = styled.div`
  border-radius: 22.5px;
  box-shadow: 0px 5px 15px rgba(0,0,0,0.1);
  display: inline-block;
  padding: 5px 10px;
  min-width: auto;
  cursor: pointer;
  color: ${variables.colours.black};
  background: ${props => props.selected ? variables.colours.lightBlue : variables.colours.white};
  margin-right: 4px;
  margin-bottom: 10px;
  font-size: 14px;
  > span {
    width: 10px;
    height: 10px;
  }
  &:hover {
    background: ${props => props.selected ? '#abeafc' : variables.colours.offwhite};
  }
  ${mixin.removeFocusOutline}
`;

export const DownloadButton = styled(FilterButton)`
  background: ${variables.colours.lightBlue}
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column-reverse;
  > * { margin-bottom: 20px; }
  @media (min-width: 400px) {
    flex-direction: row;
    justify-content: center;
    > * {
      margin-bottom: inherit;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
`;

export const ButtonNotificaton = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  min-height: 50px;
  ${mixin.spaceBetween}
  > * {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Disclaimer = styled.div`
  margin: 30px auto 0;
  max-width: 400px;
  text-align: center;
  color: rgba(0,0,0,0.4);
  font-style: italic;
  font-size: 16px;
`

export const StickyButtonContainer = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  padding: 15px 25px 20px;
  background: #fff;
  width: 100%;
  border-top: 4px solid ${variables.colours.olive};

  box-shadow: -40px -0px 40px rgba(0,0,0,0.4);

  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${mixin.spaceBetween}
  > * {
    margin-left: 0;
    margin-right: 0;
  }
  @media (min-width: 600px) {
    width: calc(66% - 20px);
  }
`;

export const InvitationButton = styled.div`
  ${mixin.buttonStyles}
  background: ${props => props.color};
  cursor: default;
`;

// Header
export const AdminHeader = styled(Header)`
  ${mixin.spaceBetween}
  align-items: center;
  img {
    max-width: 150px;
  }
  @media (min-width: 600px) {
    img {
      max-width: 200px;
    }
  }
  p {
    min-width: 80px;
    text-align: right;
  }
  a + a { margin-left: 20px; }
`;

export const AdminWrapper = styled.div`
  height: calc(100% - ${variables.headerHeight});
  ${mixin.spaceBetween}
  flex-direction: column;
`;

export const AdminPanes = styled.div`
  flex: 1;
  ${mixin.spaceBetween}
`;

export const AdminContent = styled.div`
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 600px) {
    width: 50%;
    padding: 20px;
  }
`;

export const AdminToolbox = styled.div`
  position: absolute;
  z-index: 1;
  width: 500px;
  background-color: white;
  border: 1px solid rgba(0,0,0,0.2);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 16px;
  display: none;
  ${props => props.active === true ? `
    display: block;
  ` : ''}
`;

export const ToolboxButton = styled.button`
  appearance: none;
  background: url(${toolbox}) center center no-repeat;
  background-size: 32px 32px;
  min-width: 48px;
  height: 48px;
  margin-right: 8px;
  border-radius: 48px;
  border: 1px solid ${variables.colours.grey};
  cursor: pointer;
  &:active {
    border: 1px solid ${variables.colours.lightBlue};
  }

  &:focus {
    outline:none;
  }

  &.active {
    background-color: ${variables.colours.lightBlue};
    border: 1px solid ${variables.colours.lightBlue};
  }

  &.has-filters {
    border: 4px solid ${variables.colours.lightBlue};
    box-shadow: 0px 0px 10px ${variables.colours.lightBlue};
  }
`;

export const AdminScroll = styled.div`
  flex: 1;
  overflow: auto;
`;

export const HostWrapper = styled.div`
  @media (min-width: 600px) {
    ${mixin.spaceBetween}
  }
`;
export const HostContent = styled(AdminContent)`
  > h1 {
    font-size: 1.25em;
  }
  @media (min-width: 600px) {
    width: 66%;
    padding-bottom: 145px;
    > h1 {
      font-size: 2em;
    }
  }
`;
export const HostSidebar = styled(AdminContent)`
  padding-bottom: 125px;
  height: auto;
  @media (min-width: 600px) {
    width: 33%;
    padding-bottom: 0;
  }
  h2 {
    margin-top: 20px;
    @media (min-width: 600px) {
      margin-top: 50px;
    }
    margin-bottom: 0;
    & + * {
      margin-top: 0.5em;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 2;
    li {
      a {
        padding-right: 20px;
        background: url(${downloadImage}) center right no-repeat;
        background-size: 7.5%;
      }
    }
  }
`;

export const Accordion = styled.div`
  img {
    transition: transform 250ms ease-in-out;
  }

  ${props => props.disabled === true ? `
    color: #bbb;
    cursor: not-allowed;
    span {
      font-size: 1.5rem;
      margin-left: 10px;
    }
  ` : ''}
`

export const AccordionH1 = styled.h1`
  border-radius: 10px;
  margin-top: 0;
  padding: 20px 20px 10px;
  background-color: ${variables.colours.lightGrey}
  cursor: pointer;
  font-size: 1.5em;
  display: flex;
  .title {
    flex: 1;
  }
  @media (min-width: 600px) {
    font-size: 2em;
  }
  &.admin {
    // background-color: #FCECE6; ${lighten(0.12, variables.colours.lightBlue)};
    // background-color: #E2F4F9;
    background-color: ${lighten(0.12, variables.colours.lightBlue)};
  }

  img {
    margin-top: 3px;
    height: 20px;
    width: 20px;
    margin-left: 15px;
  }
`;

export const Countdown = styled.div`
  // color: white;
  text-align: center;
  border-radius: 9px;
  padding: 12px 10px 5px;
  background-color: ${lighten(0.12, variables.colours.lightBlue)};
  font-family: ${variables.fonts.heading};
  font-size: 1.2rem;
  line-height: 1.5;
  margin-bottom: 16px;  
`;

export const TableHeader = styled.div`
  padding: 0px 15px 0px;
  font-weight: bold;
  display: flex;
  min-height: 25px;
  .name {
    width: calc((100% - 105px)*0.55);
  }
  .area {
    padding-left: 10px;
    padding-right: 10px;
    width: calc((100% - 105px)*0.45);
  }
  .guests {
    width: 105px;
  }
`;

export const EventRow = styled.div`
  list-style: none;
  padding: 15px 15px;
  display: flex;
  color: #888;
  cursor: pointer;
  ${props => props.selected ? `
    background-color: ${lighten(0.04, variables.colours.lightOrange)};
    &:hover {
      background-color: ${lighten(0.06, variables.colours.lightOrange)};
    }
    ` : `
    &:nth-child(even) {
      background-color: ${variables.colours.lightGrey};
    }
    &:hover {
      background-color: ${darken(0.02, variables.colours.white)};
      &:nth-child(even) {
        background-color: ${lighten(0.02, variables.colours.lightGrey)};
      }
    }
  `};
  .name {
    color: ${variables.colours.black}
    // flex: 1;
    line-height: 1.4;
    width: calc( (100% - 105px)*0.55);
    > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .area {
    padding-left: 10px;
    padding-right: 10px;
    width: calc( (100% - 105px)*0.45);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .guests {
    width: 105px;
  }
`;

export const FollowUp = styled.span`
  width: 12px;
  height: 12px;
  background: #06BBEF;
  margin-right: 5px;
  border-radius: 100%;
  display: inline-block;
`;

export const Incomplete = styled(FollowUp)`
  background: ${variables.colours.orange};
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 90%;
  margin-bottom: 4px;
  margin-right: 20px;
  padding-left: 10px;
`

export const RadioGroup = styled.div`
  padding: 0 15px;
  label {
    display: block;
    cursor: pointer;
    margin-top: 10px;
  }
  input {
    cursor: pointer;
  }
  @media (min-width: 600px) {
    display: ${props => props.display};
    label {
      margin-right: 15px;
    }
  }
`;

export const CheckboxGroup = styled.div`
  @media (min-width: 600px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const RadioButton = styled.input`
  margin-right: 8px;
`;

export const Select = styled.select`
  ${mixin.FormField}
  border: ${props => props.public ? '0' : "1px solid #ccc"};
  appearance: none;
  background: url(${arrow}) right 20px center no-repeat;
  background-size: 15px 15px;
`;

export const Hint = styled.div`
  padding: 0 20px;
  margin-bottom: 25px;
  color: ${variables.colours.black};
  line-height: 1.4;
`;

export const ToolTip = styled.div`
  position: absolute;
  background: ${variables.colours.orange};
  border-radius: 20px;
  top: 30px;
  right: 0;
  z-index: 1;
  box-shadow: 0px 10px 25px rgba(0,0,0,0.2);
  &.left {
    left: -100px;
    right: auto;
  }
  width: 300px;
  color: white;
  padding: 11px 20px 13px;
  line-height: 1.3;
  a {
    color: white;
  }
  .button {
    margin-top: 10px;
    display: block;
    text-decoration: underline;
  }
  &:after {
    top: -20px;
    left: 75%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: ${variables.colours.orange};
    border-width: 10px;
    margin-left: -10px;
  }
  &.left {
    &:after {
      left: 140px;
    }
  }

  @media (max-width: 600px) {

  }
`;

export const ToolTipLink = styled.span`
  display: inline-block;
  padding-left: 15px;
  position: relative;
  cursor: pointer;
  color: #0077cc;
  &:hover {
    color: #32bfcc;
  }
`;

const pulse = keyframes`
  0% {
    opacity: 0.75;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.75;
  }
`;

export const RequiredFlagLabel = styled(ToolTip)`
  top: -19px;
  left: auto;
  right: 0;
  width: auto;
  padding: 6px 20px 8px;
  animation: ${pulse} 1s linear infinite;
  &:after {
    top: 100%;
    left: 25%;
    border-bottom-color: transparent;
    border-top-color: ${variables.colours.orange};
  }
`;

export const StyledPopup = styled.div`
  background: white;
  font-size: 14px;
  font-weight: 400;
  padding: 5px;
  border-radius: 2px;

  .clickable {
    color: #0077cc;
    &:hover {
      color: #32bfcc;
    }
    text-decoration: underline;
    cursor: pointer;
    &:hover {
    }
  }
`;

const rotateImages = keyframes`
  0% {
    background-image: url("${pizza}");
  }
  33% {
    background-image: url("${sushi}");
  }
  66% {
    background-image: url("${samosas}");
  }
`;

export const ImageCarousel = styled.div`
  width: 280px;
  height: 280px;
  margin: 0px 32px;
  background-color: rgb(228, 225, 221);
  background-image: url("${pizza}");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  animation: ${rotateImages} 12s step-start;
  animation-iteration-count: infinite;
`;

export const TightParagraph = styled.p`
  margin-top: 0;
  margin-bottom: 5px;
`;

export const GuestList = styled.ul`
  padding-left: 0px;
  list-style: none;
  margin-bottom: 32px;
  margin-top: 0px;
`;

export const GuestItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px;

  &:nth-child(2n-1) {
    background-color: #eeeeee;
  }

  & > input {
    background-color: red;
  }

  .first-name {
    width: 28%;
    margin-right: 2%
  }

  .last-name {
    width: 35%;
    margin-right: 2%
  }

  .full-name {
    width: 40%;
  }

  .email {
    display: none;
  }

  .status {
    width: 30%;
    overflow: hidden;
  }

  @media screen and (min-width: 800px) {
    .full-name {
      width: 30%;
    }

    .first-name {
      width: 13%;
      overflow: hidden;
    }

    .last-name {
      width: 18%;
      overflow: hidden;
    }

    .email {
      display: block;
      width: 40%;
      margin-right: 2%;
      overflow: hidden;
    }

    .status {
      margin-right: 2%;
      overflow: hidden;
    }

    .actions {
      width: 23%;
    }
  }



`;

export const Clickable = styled.p`
  cursor: pointer;
  color: #0077cc;
  &:hover {
    color: #32bfcc;
  }
`;

// 2019 WAZZZUUPP

export const defaultFieldStyle = () => {
  return `
    border: 1px solid #ccc;
    background-color: white;

    &:focus {
      outline: none;
      border-color: white;
      box-shadow: 0px 0px 10px #45cdf4;
    }
  `
}

export const errorStyle = () => {
  return `background-color: pink;`
}

export const flex = (ai, jc, fw) => {
  return `
    display: flex;
    align-items: ${ai};
    justify-content: ${jc};
    flex-wrap: ${fw};
  `
}

export const Row = styled.div`
  > div { width: 100%; }
  
  &.twoCol {
    ${flex('center', 'space-between', 'wrap')}

    @media screen and (min-width: 600px) {
      > div {
        width: 48%;
      }
    }
  }
`;

export const Field = styled.div`
  ${flex('center', '', 'nowrap')}
`;

export const FieldLabel = styled.label`
  font-weight: 700;
`;

export const Input = styled.input`
  width: 100%;
  height: 45px;
  padding: 0px 16px;
  border-radius: 22px;
  ${defaultFieldStyle}

  &.error {
    ${errorStyle}
  }
`;